export default {
    cn: {
        tableModel: {
            userThead: ['登录账户','账户名称','启用','角色','最后登录时间','操作'],
            roleThead: ['角色','角色名称','描述','功能列表',"最后更新时间","最后更新人",'操作'],
            symbolThead: ['产品','描述','启用','小数位','更新生效','最后更新时间','最后更新人','操作'],
            userId: '登录账户',
            userName: '账户名称',
            search: "搜索",
            roleId: '角色',
            roleName: '角色名称',
            symbol: '产品',
            btnGroup:{
                refresh: '全部数据',
                addUser: '添加用户',
                addRole: '添加角色',
                deleteUser: '删除用户',
                deleteRole: '删除角色',
                confirmDelete: '确认删除',
                addSymbol: '添加产品',
                deleteSymbol: '删除产品',
            },
            showclausesnum: '显示条目数：',
            clausesamount: '条目总数：',
            present: "当前：",
            noData: '没有数据',
            confirmDeleteTips: '确认删除这些数据吗？',
            enable:{
                true: '是',
                false: '否'
            },
            readOnly: '只读',
        }
    },
    hk: {
        tableModel: {
            userThead: ['登錄賬戶','賬戶名稱','啟用','角色','最后登錄時間','操作'],
            roleThead: ['角色','角色名稱','描述','功能列表',"最后更新時間","最后更新人",'操作'],
            symbolThead: ['產品','描述','啟用','小數位','更新生效','最后更新時間','最后更新人','操作'],
            userId: '登錄賬戶',
            userName: '賬戶名稱',
            search: "搜索",
            roleId: '角色',
            roleName: '角色名稱',
            symbol: '產品',
            btnGroup:{
                refresh: '全部數據',
                addUser: '添加用戶',
                addRole: '添加角色',
                deleteUser: '刪除用戶',
                deleteRole: '刪除角色',
                confirmDelete: '確認刪除',
                addSymbol: '添加產品',
                deleteSymbol: '刪除產品',
            },
            showclausesnum: '顯示條目數：',
            clausesamount: '條目總數：',
            present: "當前：",
            noData: '沒有數據',
            confirmDeleteTips: '確認刪除這些數據嗎？',
            enable:{
                true: '是',
                false: '否'
            },
            readOnly: '只讀',
        }
    },
    en: {
        tableModel: {
            userThead: ['Login','Login Name','Enabled','Roles','Last Login Time','Opertion'],
            roleThead: ['Role','Role Name','Description','Functions',"Last Update","Update By",'Opertion'],
            symbolThead: ['Symbol','Description','Enabled','Digits','Changed','Last Update','Update By','Opertion'],
            userId: 'Login ID',
            userName: 'Login Name',
            roleId: 'Role',
            roleName: 'Role Name',
            search: "Search",
            symbol: 'Symbol',
            btnGroup:{
                refresh: 'Refresh',
                addUser: 'Add User',
                addRole: 'Add Role',
                deleteUser: 'Delete User',
                deleteRole: 'Delete Role',
                confirmDelete: 'Confirm Delete',
                addSymbol: 'Add Symbol',
                deleteSymbol: 'Delete Symbol',
            },
            showclausesnum: 'Display item number:',
            clausesamount: 'param int count:',
            present: "present:",
            noData: 'No Data',
            confirmDeleteTips: 'Are you sure to delete this data?',
            enable:{
                true: 'Yes',
                false: 'No'
            },
            readOnly: 'Read Only',
        }
    },
}


// WEBPACK FOOTER //
// ./src/language/tableModel.js